import { useEffect, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { selectInitialRegistrationDate } from "@App/state/selectors/orders";
import { setRegistrationDate } from "@App/state/action-creators";

const pad2 = (n: number) => String(n).padStart(2, "0");

/** Accepts "YYYY-MM" or "YYYY-MM-DD". Defaults day=15 for "YYYY-MM". */
const parseInitialDate = (value: string): Date | null => {
  const parts = value.split("-").map(Number);
  if (parts.length === 2) {
    const [year, month] = parts;
    if (!month || !year) return null;
    return new Date(year, month - 1, 15);
  }
  if (parts.length === 3) {
    const [year, month, day] = parts;
    if (!day || !month || !year) return null;
    return new Date(year, month - 1, day);
  }
  return null;
};

const formatInitialDate = (d: Date) =>
  `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;

export const useRegParameter = () => {
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();

  const initialRegistrationDate = useSelector(selectInitialRegistrationDate);
  const initialRegistrationDateQuery = searchParams.get("reg");

  useEffect(() => {
    if (!initialRegistrationDate && initialRegistrationDateQuery) {
      const parsed = parseInitialDate(initialRegistrationDateQuery);
      if (parsed) {
        dispatch(setRegistrationDate(parsed));
      }
    }
  }, [dispatch, initialRegistrationDate, initialRegistrationDateQuery]);

  const regParameter = useMemo(
    () => (initialRegistrationDate ? { reg: formatInitialDate(initialRegistrationDate) } : {}),
    [initialRegistrationDate],
  );

  return { regParameter };
};
